import { useCallback, useMemo, useRef } from 'react';
import { DisplayedAttribute } from 'state/tracking';
import { DisplayedUnitAttributes } from '../../types';
import { displayedUnitTrackedAttributes } from './constants';

export default function useDisplayedUnitAttribute() {
  const displayedAttrsRef = useRef<DisplayedUnitAttributes>({});

  const registerDisplayedAttribute = useCallback(
    (unitId: string, attribute: DisplayedAttribute, isDisplayed = true) => {
      const currentTrackedAttrs = displayedAttrsRef.current[unitId] ?? [];
      const trackedAttr = displayedUnitTrackedAttributes[attribute];
      const trackedAttrIndex = currentTrackedAttrs.indexOf(trackedAttr);
      const hasTrackedAttr = trackedAttrIndex >= 0;

      if (
        (isDisplayed && hasTrackedAttr) ||
        (!isDisplayed && !hasTrackedAttr)
      ) {
        return;
      }

      if (isDisplayed) {
        currentTrackedAttrs.push(trackedAttr);
      } else {
        currentTrackedAttrs.splice(trackedAttrIndex, 1);
      }

      displayedAttrsRef.current[unitId] = currentTrackedAttrs;
    },
    [],
  );

  return useMemo(
    () => ({
      registerDisplayedAttribute,
      displayedUnitAttributes: displayedAttrsRef,
    }),
    [registerDisplayedAttribute],
  );
}
